import { apiClient } from '../client';
import { Location } from '../../types/admin';

export const locationsApi = {
  list: () => apiClient.get<{ data: Location[] }>('/api/admin/locations'),
  create: (input: { name: string; level: Location['level']; parentId?: number | null }) =>
    apiClient.post<{ data: { id: number } }>('/api/admin/locations', input),
  update: (id: number, input: { name: string }) =>
    apiClient.put<{ data: { id: number } }>(`/api/admin/locations/${id}`, input),
  deactivate: (id: number) => apiClient.patch<{ data: { id: number; is_active: boolean } }>(`/api/admin/locations/${id}/deactivate`),
};
